import React, { useState } from 'react';
import { Player } from '../../../../../services/api';

interface PlayersDropdownProps {
  players: Player[];
  isHost: boolean;
}

const PlayersDropdown: React.FC<PlayersDropdownProps> = ({ players, isHost }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full bg-white/90 backdrop-blur-sm rounded-xl p-3 shadow-lg border border-white/20 hover:bg-white/95 transition-colors duration-200"
      >
        <span className="font-semibold text-gray-700">
          Players ({players.length})
        </span>
        <svg
          className={`w-4 h-4 text-gray-600 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-white/20 max-h-48 overflow-y-auto">
          {players.map((player, index) => (
            <div
              key={player.id}
              className="flex items-center justify-between px-3 py-2 hover:bg-gray-50/50 first:rounded-t-xl last:rounded-b-xl"
            >
              <span className="text-gray-800 font-medium">{player.name}</span>
              {isHost && index === 0 && (
                <span className="px-2 py-1 bg-orange-500 text-white text-xs font-bold rounded-full">
                  HOST
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlayersDropdown;